export const APP_AUTH_CONFIG_ID = '0-aurora-fe';
export const ADMIN_AUTH_CONFIG_ID = 'admin';
export const ADMIN_ROLE = 'TENANT_ONBOARDING_ADMIN';
